import React, { MouseEvent, ReactNode, useEffect, useRef, useState } from 'react';

interface ClickableTooltipProps {
  children: ReactNode;
  tooltipMessage: string;
}

const ClickableTooltip: React.FC<ClickableTooltipProps> = ({ children, tooltipMessage }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setShowTooltip(!showTooltip);
  };

  const handleClickOutside = (event: MouseEvent<HTMLDocument>) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside as any);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside as any);
    };
  }, []);

  return (
    <>
      <div ref={tooltipRef} onClick={handleClick}>
        {showTooltip && (
          <div
            className="absolute z-10 bg-gray-900 text-white py-2 px-3 rounded-lg text-xs -mt-8 shadow-lg"
            style={{ top: '-0.5rem', right: '0' }}
          >
            {tooltipMessage}
          </div>
        )}
        {children}
      </div>
    </>
  );
};

export default ClickableTooltip;
